import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-resurrect-confirmation',
    templateUrl: './resurrect-confirmation.component.html',
    styleUrls: ['./resurrect-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResurrectConfirmationComponent {
  dealInfo: any;

  constructor(
    private dialogRef: MatDialogRef<ResurrectConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      dealInfo: any
    }
  ) {
    this.dealInfo = data ? data.dealInfo : '';
    dialogRef.disableClose = true;
  }
}
